import i18next from 'i18next';
import permissions from '@shared/config/permissions';
import { INFO_PANE_PAGES } from 'redux_store';
// TODO(Phase 7): CUSTOM_TAGS_OPTIONS and FILTER_TYPES live in the
// shared Table infrastructure that still sits under _legacy/. They
// move to shared/ui/table-widgets/ and shared/config/custom-tags/
// respectively when the table widget migrates. Until then this entity
// is exempted from the no-restricted-imports boundary via .eslintrc.
import { CUSTOM_TAGS_OPTIONS } from '_legacy/components/Shared/CustomTags';
import FILTER_TYPES from '@shared/ui/Table/Filters/constants';
import { RESOURCE_STATUSES_OPTIONS } from './constants';

/**
 * Column definition factory for the resources table.
 *
 * Accepts `isPatientPage` because the resources table is reused on the
 * patient dashboard where some columns (first / last name, DOB) are
 * redundant and should be hidden.
 *
 * The shape follows the Mantine-React-Table schema extended with the
 * project's own table infrastructure (filter config, cell config,
 * permission gating, isDefaultCell toggle).
 */
export const GET_RESOURCES_COLUMNS = (isPatientPage) => [
  {
    size: 200,
    header: i18next.t('tables:customTags'),
    accessorKey: 'accountCustomTags',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: CUSTOM_TAGS_OPTIONS,
    },
    cell: {
      withBubbles: true,
    },
    permission: permissions.ACCOUNTS_GET,
  },
  {
    size: 220,
    header: i18next.t('tables:account'),
    accessorKey: 'accountBusinessName',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:customId'),
    accessorKey: 'accountCustomIdentifier',
    filter: {},
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:mrnNumber'),
    accessorKey: 'patientMrnNumber',
    filter: {},
    hidden: isPatientPage,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 240,
    header: i18next.t('tables:patientFirstName'),
    accessorKey: 'patientFirstName',
    filter: {},
    hidden: isPatientPage,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 240,
    header: i18next.t('tables:patientLastName'),
    accessorKey: 'patientLastName',
    filter: {},
    hidden: isPatientPage,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:dateOfBirth'),
    accessorKey: 'dateOfBirth',
    filter: {
      filterType: FILTER_TYPES.DATE,
    },
    hidden: isPatientPage,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 300,
    header: i18next.t('tables:resource'),
    accessorKey: 'resourceName',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:orderTimestamp'),
    accessorKey: 'orderTimestamp',
    shouldRange: true,
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 230,
    header: i18next.t('tables:appointmentTimestamp'),
    accessorKey: 'appointmentTimestamp',
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
      hasNoMaxDate: true,
    },
    isDefaultCell: true,
  },
  {
    size: 220,
    header: i18next.t('tables:invitedTimestamp'),
    accessorKey: 'invitedTimestamp',
    filter: {
      shouldRange: true,
      hasNoMaxDate: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:engagedTimestamp'),
    accessorKey: 'engagedTimestamp',
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
      hasNoMaxDate: true,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:createdBy'),
    accessorKey: 'createdBy',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:status'),
    accessorKey: 'status',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: RESOURCE_STATUSES_OPTIONS,
    },
  },
];
